<script setup lang="ts">
import { onMounted } from 'vue'
import feather from 'feather-icons';

import navbarLogo from './assets/image/navbar-logo.png';
import homeImage from './assets/image/home-img.png';


onMounted(() => {
  feather.replace();
})

</script>

<template>
  <div>

    <section class="py-10 md:py-16">

      <div class="container max-w-screen-xl mx-auto px-4">

          <nav class="flex items-center justify-between mb-40">
              <img :src="navbarLogo" alt="Logo">

              <a href="#contacts" class="px-7 py-3 md:px-9 md:py-4 bg-white font-medium md:font-semibold text-gray-700 text-md rounded-md hover:bg-amber-500 hover:text-white transition ease-linear duration-500">Contacts</a>
          </nav>

          <div class="text-center">
              <div class="flex justify-center mb-16">
                  <img :src="homeImage" alt="Image">
              </div>

              <h6 class="font-medium text-gray-600 text-lg md:text-2xl uppercase mb-8">Sistemi di cassa digitali</h6>

              <!-- <h1 class="font-normal text-gray-900 text-4xl md:text-7xl leading-none mb-8"></h1> -->

              <p class="font-normal text-gray-600 text-md md:text-xl mb-16">Website coming soon.</p>

              <a href="#contacts" class="animate-bounce px-7 py-3 md:px-9 md:py-4 font-medium md:font-semibold bg-amber-500 text-gray-50 text-sm rounded-md hover:bg-gray-50 hover:text-gray-700 transition ease-linear duration-500">Contacts</a>
          </div>

      </div>

      </section>

      <section id="contacts" class="py-10 md:py-16">

        <div class="container max-w-screen-xl mx-auto px-4">

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div class="bg-gray-50 px-8 py-10 rounded-md">
                    <div class="flex justify-center">
                        <div class="w-20 py-6 flex justify-center bg-gray-100 rounded-md mb-4">
                            <i data-feather="mail"></i>
                        </div>
                    </div>

                    <h4 class="font-medium text-gray-700 text-lg mb-4">Email</h4>

                    <p class="font-normal text-gray-500 text-md"><a href="mailto:info@primesoftware.srl">info@primesoftware.srl</a></p>
                </div>
                
                <div class="bg-gray-50 px-8 py-10 rounded-md">
                    <div class="flex justify-center">
                        <div class="w-20 py-6 flex justify-center bg-gray-100 rounded-md mb-4">
                            <i data-feather="phone-call"></i>
                        </div>
                    </div>

                    <h4 class="font-medium text-gray-700 text-lg mb-4">Phone</h4>

                    <p class="font-normal text-gray-500 text-md"><a href="callto:+39 347 7945360">+39 347 7945360</a></p>
                </div>
                
                <div class="bg-gray-50 px-8 py-10 rounded-md">
                    <div class="flex justify-center">                    
                        <div class="w-20 py-6 flex justify-center bg-gray-100 rounded-md mb-4">
                            <i data-feather="map-pin"></i>
                        </div>
                    </div>

                    <h4 class="font-medium text-gray-700 text-lg mb-4">Address</h4>

                    <p class="font-normal text-gray-500 text-md">Viale Volontari della Libertà 4 <br />
                      33100 Udine - Italy</p>
                </div>
            </div>

        </div>

        </section>

  </div>
</template>

<style scoped></style>
